import React from "react";
import "../../global/global.css";

const InputBox = ({ label, placeholder, onChangeFunc, value }) => {
  return (
    <>
      <div className="user-input-box">
        <label>{label}</label>
        <input
          type="text"
          placeholder={placeholder}
          className="input-box"
          onChange={onChangeFunc}
          value={value}
        />
      </div>
    </>
  );
};

export default InputBox;
